import { ClipLoader } from "react-spinners"
import styles from "../../services/styles";
import { useContext } from "react";
import GeneralContext from "../../context/GeneralContext/GeneralContext";

const { COLORS } = styles

export default function Loader(props) {
  const {
    show_loading, setShowLoading,
  } = useContext(GeneralContext)

  return (
    show_loading
      ?
      <div>
        <div style={{ position: 'fixed', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9998, width: '100%', height: '100%', background: COLORS.RED[900], opacity: 0.2 }} />

        <div style={{ position: 'fixed', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, width: '100%', height: '100%' }}>
          <ClipLoader
            color={"#fff"}
            loading={true}
            cssOverride={{
              display: 'block',
              margin: '0 auto',
              borderColor: COLORS.RED[900]
            }}
            size={30}
          />
        </div>
      </div>
      :
      null
  )
}